import { EditCollaborateurPage } from "@features/rh/collaborateurs/components/EditCollaborateurPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { UserCog } from "lucide-react";

export const Route = createFileRoute("/_app/rh/collaborateurs/$id/edit")({
  loader: requirePermission(PERMISSIONS.RH.PERSONNE.EDIT),
  staticData: {
    title: "Modifier un collaborateur",
    icon: UserCog,
    permission: PERMISSIONS.RH.PERSONNE.EDIT,
    section: "App",
    showInBreadcrumb: true,
  },
  component: EditCollaborateurPage,
});
